<div class="fs-2 with-close" mat-dialog-title>
    Renommer cette simulation
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <mat-form-field>
        <mat-label>Titre</mat-label>
        <input class="text" matInput [(ngModel)]="favorite.title">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
